import { render } from "./MetaCallback.vue?vue&type=template&id=9fc2275e&scoped=true"
import script from "./MetaCallback.vue?vue&type=script&lang=js"
export * from "./MetaCallback.vue?vue&type=script&lang=js"

import "./MetaCallback.vue?vue&type=style&index=0&id=9fc2275e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9fc2275e"]])

export default __exports__